import { KitElement } from 'shared/kit/kit-element';
import { KitTypeSetting, TeamIndex } from 'shared/kit/resolve-team-color';

/** Значение `data.fill.source`, по которому реплейсер узнаёт объект, красящийся цветом команды. */
export const TEAM_COLOR_SOURCE = 'teamColor';

/**
 * Как заливать объект цветом формы:
 * - `fill` — самим цветом команды;
 * - `contrast` — чёрным или белым, читаемым поверх этого цвета (для текста на плашке команды).
 */
export type TeamColorFillMode = 'fill' | 'contrast';

/**
 * Контракт заливки цветом команды. Лежит в `object.data.fill` и переживает `getScheme()`:
 * заливка — свойство объекта, а не отдельный плейсхолдер, поэтому цветом команды красится
 * уже существующая графика шаблона.
 */
export interface TeamColorFill {
  source: typeof TEAM_COLOR_SOURCE;
  teamIndex: TeamIndex;
  kitType?: KitTypeSetting;
  /** Элемент формы, с которого берётся цвет. По умолчанию футболка. */
  element?: KitElement;
  /** 0 — основной цвет, 1 — цвет узора. */
  colorIndex?: number;
  mode?: TeamColorFillMode;
}

/** Объект канвы красится цветом команды. Старые доски поля `fill` не имеют — им false. */
export function isTeamColorFill(fill: unknown): fill is TeamColorFill {
  return typeof fill === 'object' && fill !== null && (fill as TeamColorFill).source === TEAM_COLOR_SOURCE;
}
